import { gql } from 'urql';
import { PRODUCT } from '../client';

export const DISPATCH_PROVIDER_ROUTE = gql`
  mutation ${PRODUCT}DispatchProviderRoute($input: DispatchProviderRouteInput!) {
    dispatchProviderRoute(input: $input) {
      route {
        id
        providerDispatch {
          status
          error
        }
      }
      userErrors {
        __typename
        ... on UserErrorInterface {
          message
        }
      }
    }
  }
`;
